import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";

import { getSortFunction } from "./get-sort-function";
import { Result } from "../../models/result";
import { SortOptionMap } from "../../models/sorting/sort-option-map";

/**  */
export function sortResultList(
	results: Result[],
	sortOptionId: string,
	sortOptions: SortOptionMap,
) {
	if (isStringEmpty(sortOptionId)) {
		return results;
	}

	//If the passed in option does not exist in the possible set of search options
	// then do nothing.
	var option = sortOptions[sortOptionId];
	if (option === undefined) {
		return results;
	}

	//Attempt to get a sort function for the provided sort option id
	var sortFunction = getSortFunction(sortOptionId);
	if (sortFunction === null || sortFunction === undefined) {
		return results;
	}

	//return results;
	if (sortOptionId == "name-az" || sortOptionId == "city-az") {
		// return all results sorted, including call for info
		return results.slice().sort(sortFunction);
	}
	else {

		// separate call for info items
		const callForInfoResults = results.filter(result => result?.showCallForInfo == true);
		const valuedResults = results.filter(result => result?.showCallForInfo == false);

		const sortedValuedResults = [...valuedResults].sort(sortFunction);
		const finalSortedResults = [...sortedValuedResults, ...callForInfoResults];

		return finalSortedResults;
	}
}
